/**
 * <dialog-element> — thin wrapper around a native <dialog>.
 *
 * Contract:
 * - Must contain exactly one <dialog> child.
 * - Any button inside with [data-dialog-close] closes it.
 * - Clicking the backdrop closes it.
 * - Any element on the page with [data-dialog-open="<id>"] opens the
 *   <dialog-element> with that id (delegated listener below).
 */
export class DialogElement extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    if (!this.dialog) return;

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) this.hide();
    });

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-dialog-close]')) this.hide();
    });
  }

  show() {
    if (this.dialog && !this.dialog.open) this.dialog.showModal();
  }

  hide() {
    this.dialog?.close();
  }
}

if (!customElements.get('dialog-element')) {
  customElements.define('dialog-element', DialogElement);
}

document.addEventListener('click', (event) => {
  const opener = event.target.closest('[data-dialog-open]');
  if (!opener) return;

  const target = document.getElementById(opener.dataset.dialogOpen);
  if (target instanceof DialogElement) {
    event.preventDefault();
    target.show();
  }
});
